import React from "react";
const AccordionTitle = ({ children, className = "" }) => {
  return <>{children}</>;
};

export default AccordionTitle;
